<template>
    <div class="omikuji">
        <p>今日の運勢は…？</p>
        <div class="omikuji_start">
            <button @click="startOmikuji">おみくじを引く</button>
        </div>
        <div class="omikuji_result">
            <p v-if="result">あなたは：{{result}}です！</p>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            choice: ["大吉", "中吉", "小吉", "凶"],
            result: null,
        }
    },
    methods:{
        startOmikuji(){
            //ランダムで相手の数字を決定する
            var num = Math.floor( Math.random()*4 );
            this.result = this.choice[num]
        }
    }
}
</script>

<style scoped>

</style>